import React from 'react';
import { ThemeColors } from '../../../../Context/ThemeContext';
import { PeriodDropdown, PeriodOption } from './PeriodDropdown';

interface StatCardProps {
  label: string;
  value: string;
  change: string;
  positive: boolean;
  theme: ThemeColors;
  isMobile: boolean;
  period: PeriodOption;
  onPeriodChange: (value: PeriodOption) => void;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  change,
  positive,
  theme,
  isMobile,
  period,
  onPeriodChange,
}) => {
  // Check if the change is 0% (e.g., "+0.00%", "0%", "+0%")
  const isNoChange = /^[+-]?0(\.0+)?%/.test(change);

  const styles = {
    card: {
      background: theme.card,
      borderRadius: '8px',
      padding: '16px',
      position: 'relative' as const,
      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    },
    statLabel: {
      fontSize: '13px',
      color: theme.textSecondary,
      marginBottom: '6px',
      fontWeight: 500,
    },
    statValue: {
      fontSize: isMobile ? '28px' : '32px',
      fontWeight: 700,
      color: theme.text,
      marginBottom: '6px',
      lineHeight: 1.1,
    },
    statChange: {
      fontSize: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      fontWeight: 500,
      color: isNoChange ? '#6b7280' : positive ? '#22c55e' : '#ef4444',
    },
  };

  // Extract the period label from the change string (e.g., "from yesterday")
  const periodLabel = change.replace(/^[+-]?\d+(\.\d+)?%\s*/, '');

  return (
    <div style={styles.card}>
      <PeriodDropdown
        value={period}
        onChange={onPeriodChange}
        theme={theme}
        style={{ top: '10px', right: '10px' }}
      />
      <div style={styles.statLabel}>{label}</div>
      <div style={styles.statValue}>{value}</div>
      <div style={styles.statChange}>
        {isNoChange ? (
          <>No Change {periodLabel}</>
        ) : (
          <>
            <span>{positive ? '↑' : '↓'}</span>
            {change}
          </>
        )}
      </div>
    </div>
  );
};
